export interface AssociationItem {
    text: string;
    category: string;
    custom?: boolean;
}

export const CUSTOM_CATEGORY = 'Свои';

export const BASE_WORDS: AssociationItem[] = [
    // Предметы
    {text: 'Зонт', category: 'Предметы'},
    {text: 'Часы', category: 'Предметы'},
    {text: 'Очки', category: 'Предметы'},
    {text: 'Ключ', category: 'Предметы'},
    {text: 'Свеча', category: 'Предметы'},
    {text: 'Зеркало', category: 'Предметы'},
    {text: 'Компас', category: 'Предметы'},
    {text: 'Гамак', category: 'Предметы'},
    {text: 'Термос', category: 'Предметы'},
    {text: 'Расчёска', category: 'Предметы'},

    // Природа
    {text: 'Радуга', category: 'Природа'},
    {text: 'Вулкан', category: 'Природа'},
    {text: 'Айсберг', category: 'Природа'},
    {text: 'Водопад', category: 'Природа'},
    {text: 'Пустыня', category: 'Природа'},
    {text: 'Ураган', category: 'Природа'},
    {text: 'Закат', category: 'Природа'},
    {text: 'Гроза', category: 'Природа'},
    {text: 'Лес', category: 'Природа'},
    {text: 'Океан', category: 'Природа'},

    // Еда
    {text: 'Пицца', category: 'Еда'},
    {text: 'Мёд', category: 'Еда'},
    {text: 'Арбуз', category: 'Еда'},
    {text: 'Шоколад', category: 'Еда'},
    {text: 'Суши', category: 'Еда'},
    {text: 'Блины', category: 'Еда'},
    {text: 'Мороженое', category: 'Еда'},
    {text: 'Попкорн', category: 'Еда'},
    {text: 'Лимон', category: 'Еда'},
    {text: 'Хлеб', category: 'Еда'},

    // Места
    {text: 'Пляж', category: 'Места'},
    {text: 'Аэропорт', category: 'Места'},
    {text: 'Библиотека', category: 'Места'},
    {text: 'Маяк', category: 'Места'},
    {text: 'Крепость', category: 'Места'},
    {text: 'Пирамида', category: 'Места'},
    {text: 'Стадион', category: 'Места'},
    {text: 'Цирк', category: 'Места'},
    {text: 'Метро', category: 'Места'},
    {text: 'Оазис', category: 'Места'},

    // Профессии
    {text: 'Пожарный', category: 'Профессии'},
    {text: 'Хирург', category: 'Профессии'},
    {text: 'Космонавт', category: 'Профессии'},
    {text: 'Художник', category: 'Профессии'},
    {text: 'Дирижёр', category: 'Профессии'},
    {text: 'Дегустатор', category: 'Профессии'},
    {text: 'Археолог', category: 'Профессии'},
    {text: 'Дрессировщик', category: 'Профессии'},
    {text: 'Часовщик', category: 'Профессии'},
    {text: 'Пасечник', category: 'Профессии'},
];
